import { useWebCallContext } from './Common/WebCallContext'; // Import the context hook
import call_cancel from './Components/Agents/assets/images/call-cancel.svg';
import transcriptVisible from './Components/Agents/assets/images/transcript-visible.png';
import transcriptHidden from './Components/Agents/assets/images/transcript-hidden.png';
import { Popover } from 'reactstrap';
import cx from "classnames";
import React ,{ useEffect, useRef, useState } from 'react';
import Loading from './Common/Loading';
import { useAppContext } from './Context/AppContext';
import { getIconByVoiceId } from './Common/Appcommon';

const WebCallPopOver = () => {
    const {
        isPopoverOpen, 
        toggleFun, 
        agentname, 
        stopCall, 
        isCallReady,
        curDuaration, 
        transcript,
        showTranscript,
        setShowTranscript,
        showLoading,
        setShowLoading,
        voiceIcon
    } = useWebCallContext(); 
    const { voiceAgList } = useAppContext();
    const transcriptRef = useRef(null);
    useEffect(() => {
        let icon = getIconByVoiceId(voiceIcon,voiceAgList[0]);
        setIcon(icon)
    }, [isPopoverOpen, isCallReady, stopCall,toggleFun,transcript, showTranscript, setShowTranscript,]);

    useEffect(()=>{
        if(curDuaration !== '0:00'){
            setShowLoading(false);
        }
    },[curDuaration])
    const [transcriptImage,setTranscriptImage] = useState(showTranscript ? transcriptVisible : transcriptHidden);
    const [icon,setIcon] = useState('');
    const onClickTranscript = () => {
        const newValue = !showTranscript;
        setShowTranscript(!showTranscript);
        if (newValue) {
            setTranscriptImage(transcriptVisible);
        } else {
            setTranscriptImage(transcriptHidden);
        }
    };
    
    useEffect(() => {
        if (transcriptRef.current) {
            transcriptRef.current.scrollTop = transcriptRef.current.scrollHeight;
        }
    }, [transcript]);
    return (
        <>
            <div className="app-footer-right agent-footer">
                <div id="WebCall"></div>
                {isCallReady && (
                    <Popover
                        className="rm-max-width"
                        innerClassName={`agent-popover ${showTranscript && "agent-popover-transcript"}`}
                        placement="bottom-start"
                        fade={false}
                        hideArrow
                        isOpen={isPopoverOpen}
                        target="WebCall"
                        toggle={() => toggleFun && toggleFun()}
                    >

                        <>
                            <div className={showTranscript ? 'd-flex align-items-center  w-100' : 'agent-popover-heading'}>
                                <div className={showTranscript ? 'agents-call-details-transcript col-md-8 d-flex justify-content-start' : 'agents-call-details'}>
                                    <span className="agent-call-icon">{!icon ? <i className="fi fi-ss-user-headset"></i> : <img src={icon} className={"voice-img-crop"} alt="Agent Icon"/>}</span> 
                                    <span className={showTranscript ? 'ms-3' : ''}>{agentname}</span>
                                </div>
                                <div className={showTranscript ? 'col d-flex justify-content-end' : ''}>
                                    {
                                        curDuaration === "Connecting" ? (
                                            <div className="connecting">
                                                Connecting<span className="dots"></span>
                                            </div>
                                        ) : (
                                            <span>{curDuaration || "0:00"}</span>
                                        )
                                    }
                                </div>
                            </div>
                            <div className={showTranscript ? 'popover-transcript-container' : 'agent-popover-body'} ref={transcriptRef}>
                                {transcript && showTranscript && transcript.length > 0 ? (
                                    <div className="">
                                        {transcript.map((field, index) => {
                                            return (
                                                <div key={index}>
                                                    {field.role === "agent" && (
                                                        <div className='popover-transcript-contant-agent w-100'>
                                                            <div className='transcript-dur'>
                                                                <span className='transcript-bot-name'>{agentname}</span>
                                                            </div>
                                                            <div className='transcript-bot-msg-width'>
                                                                <div>{field.content}</div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {field.role === "user" && (
                                                        <div className='popover-transcript-contant-user w-100'>
                                                            <div className='transcript-user-header'>
                                                                <span>User</span>
                                                            </div>
                                                            <div className='transcript-bot-msg-width'>
                                                                <div>{field.content}</div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <> </>
                                )}
                            </div>
                            <div className='agent-popover-footer-container'>
                                <div className='agent-popover-footer me-2'>
                                    <img className={`agent-cancel-call popover-transcript-image  ${curDuaration === "Connecting" && "cursor-not-allowed"}`} src={transcriptImage} alt = "Transcript" onClick={() => curDuaration !== "Connecting"  && setShowTranscript && onClickTranscript()}/> 
                                </div>
                                <div className='agent-popover-footer ms-2'>
                                    <img className={`agent-cancel-call ${curDuaration === "Connecting" && "cursor-not-allowed"}`} src={call_cancel} alt="Call Cancel" onClick={() => curDuaration !== "Connecting"  && stopCall && stopCall()}/> 
                                </div>
                            </div>
                        </>
                    </Popover>
                )}
            </div>
        </>
    );
};

export default WebCallPopOver;
